import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { PageResponse } from 'src/app/auth/base-capacitor-http';
import { Move, MoveSearchParams, MoveSortOption, MovesService, MoveStatus, MoveUpdateOption } from 'src/app/services/app/moves.service';
import { Trailer, TrailerStatus } from 'src/app/services/app/trailer.service';
import { UtilitieService } from 'src/app/services/utils/utilities.service';
import { Yard, YardService, YardStatus } from 'src/app/services/app/yard.service';
import { UpdateMessage, UpdateMessageType, WebsocketService } from 'src/app/services/utils/websocket.service';

@Component({
  selector: 'app-moves',
  templateUrl: './moves.component.html',
  styleUrls: ['./moves.component.css'],
})
export class MovesComponent implements OnInit {
  page: PageResponse<Move>;
  pageSizeOptions = [5, 10, 25];
  searchParams: MoveSearchParams;

  viewModes = ['movesList', 'moveView', 'redirectMode'];
  viewMode = this.viewModes[0];
  selectedMove: Move;
  // used to enable move redirection
  openYardSpots: Yard[];
  isLoading: boolean = false;

  constructor(private moveService: MovesService, private yardService: YardService, private websocketService: WebsocketService, private utilService: UtilitieService) { }
  
  viewMove(move: Move) {
    this.selectedMove = move;
    this.viewMode = this.viewModes[1];
  }

  bckToViewMode() {
    this.viewMode = this.viewModes[1];
  }

  viewMoves() {
    this.viewMode = this.viewModes[0];
  }

  async markAsComplete() {
    /**
     * for this the move needs to be marked as completed and the
     * yards need to be updated accordingly to reserve the the spots and prevent
     * furthe assignment to them.
     *
     * remove move from assignments and add them into completed move list.
     */


    const move = await this.moveService.updateMove(MoveUpdateOption.COMPLETE, this.selectedMove, null);
    const index = this.page.data.findIndex(m => m.id === move.id);
    this.page.data.splice(index, 1);
    this.viewMode = this.viewModes[0];

    this.selectedMove = null;

  }
  redirectMode() {
    this.viewMode = this.viewModes[2];
  }

  async redirectMove(yard: Yard) {
    const confirmation = await this.utilService.openConfirmationDialog('Trailer reroute', 'Are you sure you want to reroute this assignment to location ' + yard.location);
    if (confirmation) {
     
      const move = await this.moveService.updateMove(MoveUpdateOption.REDIRECT, this.selectedMove, yard);
      this.utilService.openSnackBar('Reroute was succesfull', '');
      this.viewMode = this.viewModes[1];
      this.selectedMove.end = yard;
    }
  }

  // function to set color for the truck icon.
  setTruckStatus(move: Move) {
    // setting truck defaut status
    let truckColor = { color: 'white' };


    switch (move.start.trailer.status) {
      case TrailerStatus.LOADED:
        truckColor.color = 'green';
        return truckColor;
      case TrailerStatus.EMPTY:
        truckColor.color = 'white';
        return truckColor;
      case TrailerStatus.OUT_OF_SERVICE:
        truckColor.color = 'red';
        return truckColor;
      default:
        return truckColor;
    }

  }
  async searchMoves() {
    this.page = await this.moveService.searchMovesByStatus(this.searchParams);
  }

  async handlePageEvent(e: PageEvent) {
    this.searchParams.size = e.pageSize;
    this.searchParams.page = e.pageIndex;
    this.searchMoves();
  }

  listenToUpdates() {
    this.websocketService.getUpdateMessages()
      .subscribe(update => {
        this.processUpdate(update);
      });
  }

  private processUpdate(update: UpdateMessage) {
    let index: number;
    if (!update) {
      return;
    }
    switch (update.type) {
      case UpdateMessageType.MOVE:
        const move: Move = JSON.parse(update.data);
        index = this.page.data.findIndex(m => m.id === move.id);
        if (index > -1) {
          this.page.data[index] = move;
        }
        break;
      case UpdateMessageType.YARD:
        const yard: Yard = JSON.parse(update.data);
        if (yard.status === YardStatus.EMPTY) {
          this.openYardSpots.push(yard);
          return;
        }
        index = this.openYardSpots.findIndex(y => y.id === yard.id);
        if (index > -1) {
          this.openYardSpots.splice(index, 1);
        }
        break;
    }
  }


  onScroll(event: Event) {
    const element = event.target as HTMLElement;

    // Calculate the scroll position
    const { scrollTop, scrollHeight, clientHeight } = element;

    // Buffer: Trigger 50px before the actual end to ensure smooth loading
    const buffer = 50;

    // Check if we are near the bottom
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - buffer;

    if (isAtBottom) {
      // Prevent duplicate calls if already loading


    }
  }


  async ngOnInit(): Promise<void> {
    this.utilService.updateLoading(true);
    this.page = new PageResponse();
    this.openYardSpots = [];
    this.searchParams = {
      page: 0,
      size: 10,
      completed: true,
      start: null,
      end: null,
      sort: MoveSortOption.CREATED_NEW,
      search: MoveStatus.PENDING
    };

    await this.searchMoves();
    this.openYardSpots = await this.yardService.getAllOpenYards();
    this.utilService.updateLoading(false);
    this.listenToUpdates();
  }

}
